import React, { useState } from 'react';
import useInView from './useInView';

const projects = [
  { cat: 'Civil Engineering', name: 'Site Equipment & Mobilisation', img: '/projects/equipment-site.jpg', large: true },
  { cat: 'Building Construction', name: 'Commercial Development', img: '/projects/commercial-building.jpg' },
  { cat: 'Infrastructure', name: 'Road Construction', img: '/projects/road-construction.jpg' },
  { cat: 'Water Engineering', name: 'Borehole & Water Treatment', img: '/projects/borehole-water.jpg' },
  { cat: 'Electrical', name: 'Power & Electrical Installation', img: 'https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?w=700&q=80&fit=crop' },
];

export default function Projects() {
  const [hovered, setHovered] = useState(null);
  const [ref, inView] = useInView();

  return (
    <section id="projects" style={{ padding: 'clamp(3rem, 8vw, 8rem) 0', background: 'var(--off-white)' }}>
      <div className="section-wrap">
        {/* Header */}
        <div ref={ref} style={{
          display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end',
          marginBottom: '2.5rem', flexWrap: 'wrap', gap: '1.5rem',
          opacity: inView ? 1 : 0, transform: inView ? 'none' : 'translateY(24px)',
          transition: 'all 0.7s ease',
        }}>
          <div>
            <div className="section-label">Our Work</div>
            <h2 className="section-title">Project <span>Portfolio</span></h2>
          </div>
          <a href="#contact" className="btn-primary"><span>Discuss a Project</span></a>
        </div>

        {/* Grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: '1.6fr 1fr 1fr',
          gridTemplateRows: '340px 260px',
          gap: 4,
          opacity: inView ? 1 : 0, transition: 'opacity 0.8s ease 0.2s',
        }}>
          {projects.map((p, i) => (
            <div key={i}
              onMouseEnter={() => setHovered(i)}
              onMouseLeave={() => setHovered(null)}
              style={{
                gridRow: i === 0 ? '1 / 3' : 'auto',
                position: 'relative', overflow: 'hidden', cursor: 'pointer',
              }}>
              {/* Image */}
              <img src={p.img} alt={p.name} style={{
                position: 'absolute', inset: 0, width: '100%', height: '100%',
                objectFit: 'cover', objectPosition: 'center',
                transform: hovered === i ? 'scale(1.07)' : 'scale(1)',
                transition: 'transform 0.6s ease',
              }} />

              {/* Overlay */}
              <div style={{
                position: 'absolute', inset: 0,
                background: hovered === i
                  ? 'linear-gradient(to top, rgba(26,79,156,0.9) 0%, rgba(10,22,40,0.4) 70%)'
                  : 'linear-gradient(to top, rgba(10,22,40,0.88) 0%, rgba(10,22,40,0.1) 60%)',
                transition: 'background 0.4s ease',
              }} />

              {/* Info */}
              <div style={{
                position: 'absolute', bottom: 0, left: 0, right: 0, padding: '2rem',
                transform: hovered === i ? 'translateY(0)' : 'translateY(4px)',
                transition: 'transform 0.3s ease',
              }}>
                <div style={{
                  fontFamily: "'Barlow Condensed', sans-serif",
                  fontSize: '0.65rem', fontWeight: 700,
                  letterSpacing: '0.28em', textTransform: 'uppercase',
                  color: hovered === i ? '#7aaef0' : 'var(--blue)',
                  marginBottom: '0.4rem',
                }}>{p.cat}</div>
                <div style={{
                  fontFamily: "'Bebas Neue', sans-serif",
                  fontSize: i === 0 ? '1.9rem' : '1.2rem',
                  color: 'white', lineHeight: 1.1, letterSpacing: '0.02em',
                }}>{p.name}</div>

                {/* Arrow on hover */}
                <div style={{
                  marginTop: '0.8rem',
                  display: 'flex', alignItems: 'center', gap: '0.5rem',
                  fontFamily: "'Barlow Condensed', sans-serif",
                  fontSize: '0.75rem', fontWeight: 700,
                  letterSpacing: '0.14em', textTransform: 'uppercase', color: 'white',
                  opacity: hovered === i ? 1 : 0, transform: hovered === i ? 'translateX(0)' : 'translateX(-10px)',
                  transition: 'all 0.3s ease',
                }}>
                  View Project
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 12h14M12 5l7 7-7 7" /></svg>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @media (max-width: 900px) {
          #projects .section-wrap > div:last-child {
            grid-template-columns: 1fr !important;
            grid-template-rows: auto !important;
          }
          #projects .section-wrap > div:last-child > div:first-child { grid-row: auto !important; height: 280px; }
          #projects .section-wrap > div:last-child > div { height: 220px; }
        }
      `}</style>
    </section>
  );
}
